import {  useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchInitialState, updateOfficeSpaceOtherBusinessPrivatePlace } from './officeSpaceOtherBusinessSlice';
import Loader from '../../components/loader';
import { OptionCard, OptionCardRow, OptionCardSeparator, StepHeading, StepShell } from '../../components/optionCard';

const OfficeSpaceOtherBusinessDetails = () => {
    const dispatch = useDispatch();
    const officeSpaceOtherBusinessDetailsState = useSelector(state => state.other_businesses);

    useEffect(() => {
        dispatch(fetchInitialState());
    },[dispatch])



    return (
        <>
            { officeSpaceOtherBusinessDetailsState.loading && <Loader /> }
            <StepShell className="mb-14">
                <StepHeading>
                    Does your location have a private place to meet, exclusive to mortgage, behind a closed door?
                </StepHeading>
                <OptionCardRow>
                    {/* Yes Option */}
                    <OptionCard
                        selected={officeSpaceOtherBusinessDetailsState.data.office_space_detail.place_option === 'Yes'}
                        onClick={() => dispatch(updateOfficeSpaceOtherBusinessPrivatePlace('Yes'))}
                    >
                        Yes
                    </OptionCard>

                    <OptionCardSeparator />

                    {/* No Option */}
                    <OptionCard
                        selected={officeSpaceOtherBusinessDetailsState.data.office_space_detail.place_option === 'No'}
                        onClick={() => dispatch(updateOfficeSpaceOtherBusinessPrivatePlace('No'))}
                    >
                        No
                    </OptionCard>
                </OptionCardRow>

            </StepShell>


        </>

    )
}

export default OfficeSpaceOtherBusinessDetails;
